import React from 'react';
import { SiteConfig } from '../types';

interface FooterProps {
  siteConfig: SiteConfig | null;
}

export const Footer: React.FC<FooterProps> = ({ siteConfig }) => (
  <footer className="bg-black text-white mt-32 shadow-2xl">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
      <div className="text-center">
        <p className="text-gray-400 text-base font-headline font-bold uppercase tracking-widest">
          © 2024 {siteConfig?.siteName || ''}
        </p>
      </div>
    </div>
  </footer>
);